import {
  Notifications,
  Reminder,
  ReminderBasedOn,
  TranslateFunction,
} from '@griply/types';

import { getReminderOptions } from './get-reminder-options';

export const NO_TASK_REMINDER_VALUE = 'none';

export type TaskReminderSettingOption = {
  value: string;
  label: string;
};

export const getTaskReminderSettingOptions = (
  basedOn: ReminderBasedOn,
  t: TranslateFunction,
): TaskReminderSettingOption[] => [
  { value: NO_TASK_REMINDER_VALUE, label: t('reminders.none') },
  ...getReminderOptions(basedOn).map((preset) => ({
    value: String(preset.offset),
    label: t(preset.labelKey),
  })),
];

export const getTaskReminderSettingValue = (
  reminder: Reminder | null,
): string => (reminder ? String(reminder.offset) : NO_TASK_REMINDER_VALUE);

// A cleared selection and the none option both persist as null so the backend reads "no reminder".
export const getTaskReminderSettingUpdate = (
  notifications: Notifications | undefined,
  basedOn: ReminderBasedOn,
  value: string | undefined,
): Notifications => {
  const time = value && value !== NO_TASK_REMINDER_VALUE ? Number(value) : null;

  if (basedOn === ReminderBasedOn.Start) {
    return { ...notifications, plannedTask: { time } };
  }

  return { ...notifications, allDayTask: { time } };
};
